import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { PRIMARY_COLOR } from '../color-constants';

const Container = styled.div`
  display: flex;
`;

const BusContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const BusNameWrapper = styled.div`
  position: relative;
  display: flex;
  height: 10px;
  ${props => props.isBusHeadModule ? `width: 50%;` : 'width: 100%;'}
`;

const BusWrapper = styled.div`
  width: 100%;
  display: flex;
  height: 20px;
  flex-direction: row;
  align-items: center;
  ${props => props.isBusHeadModule ? `justify-content: flex-end` : ''}
`;

const BusName = styled.span`
  position: absolute;
  top: 0; left: 0;
  display: block;
  font-size: 10px;
  line-height: 10px;
  white-space: nowrap;
`;

const BusExtremity = styled.div`
  width: 10px; height: 10px;
  min-width: 10px; min-height: 10px;
  background-color: ${PRIMARY_COLOR};
  background-color: var(--se-secondary, ${PRIMARY_COLOR});
  transform: rotate(45deg);
`;

const BusExtremityWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 50%;
`;

const BusLine = styled.div`
  width: 100%;
  height: 3px;
  background-color: ${PRIMARY_COLOR};
  background-color: var(--se-secondary, ${PRIMARY_COLOR});
`;

class PowerSupplyBusFragment extends React.Component {

  static propTypes = {
    busName: PropTypes.string,
    busLength: PropTypes.number,
    isBusHeadModule: PropTypes.bool,
    isBusLastModule: PropTypes.bool
  }

  render = () => {
    const isBusHeadModule = this.props.isBusHeadModule;
    const isBusLastModule = !isBusHeadModule && this.props.isBusLastModule;
    return (
      <Container >
        <BusContentWrapper>
          <BusNameWrapper isBusHeadModule={isBusHeadModule}>
            {isBusHeadModule && <BusName>{this.props.busName}</BusName>}
          </BusNameWrapper>
          <BusWrapper isBusHeadModule={isBusHeadModule}>
            {isBusHeadModule &&
              <BusExtremityWrapper>
                <BusExtremity></BusExtremity>
                {this.props.busLength > 1 && <BusLine></BusLine>}
              </BusExtremityWrapper>
            }
            {isBusLastModule &&
              <BusExtremityWrapper>
                <BusLine></BusLine>
                <BusExtremity></BusExtremity>
              </BusExtremityWrapper>
            }
            {!isBusHeadModule && !isBusLastModule &&
              <BusLine></BusLine>
            }
          </BusWrapper>
        </BusContentWrapper>
      </Container>
    );
  }
}

export default PowerSupplyBusFragment;
